import { UseQueryResult } from "@tanstack/react-query";
import { ISbStoryData } from "@storyblok/react";
import { useStoryblokProxy } from "./useStoryblokProxy";
import { UseFetchOptions } from "../types/StoryblokTypes";
import { AxiosHeaders } from "axios";

interface ConfigResponse {
  storyData: ISbStoryData | null;
  headers: AxiosHeaders;
}
export const configSlug = "config";

export const useConfig = (
  args: UseFetchOptions = { by_slugs: configSlug },
  abortRequest?: boolean
): UseQueryResult<ConfigResponse> => {
  const storyblokData = useStoryblokProxy(args, abortRequest);

  return {
    ...storyblokData,
    data: {
      storyData: storyblokData.data?.stories?.[0] ?? null,
      headers: storyblokData.data?.headers,
    },
  } as unknown as UseQueryResult<ConfigResponse>;
};
